/**
 * CrediarioModal — forma de recebimento Crediário (venda a prazo → contas a receber no caixa)
 */

import { useState, useEffect } from 'react'
import Modal from '../../../../../components/ERP/Modal/Modal'
import FormField from '../../../../../components/ERP/Form/FormField'
import { CalendarClock } from 'lucide-react'

function CrediarioModal({ isOpen, onClose, onSubmit, editingForma, errors }) {
  const [formData, setFormData] = useState({
    name: 'Crediário',
    description: 'Venda a prazo — gera contas a receber ao finalizar no caixa',
    active: true
  })

  useEffect(() => {
    if (editingForma) {
      setFormData({
        name: editingForma.name || 'Crediário',
        description: editingForma.description || '',
        active: editingForma.active !== undefined ? editingForma.active : true
      })
    } else {
      setFormData({
        name: 'Crediário',
        description: 'Venda a prazo — gera contas a receber ao finalizar no caixa',
        active: true
      })
    }
  }, [editingForma, isOpen])

  const handleSubmit = (e) => {
    e.preventDefault()
    onSubmit({
      ...formData,
      accountId: null,
      provider: 'CREDIÁRIO',
      paymentType: 'CREDIÁRIO',
      taxRate: 0,
      installments: null,
      cardBrand: null,
      requiresConfirmation: false
    })
  }

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={editingForma ? 'Editar Crediário' : 'Nova Forma: Crediário'}
      icon={<CalendarClock size={24} />}
      size="medium"
      footer={
        <>
          <button type="button" className="btn-secondary" onClick={onClose}>
            Cancelar
          </button>
          <button type="button" className="btn-primary" onClick={handleSubmit}>
            {editingForma ? 'Salvar' : 'Criar'}
          </button>
        </>
      }
    >
      <form onSubmit={handleSubmit}>
        <FormField
          label="Nome"
          value={formData.name}
          onChange={(e) => setFormData((prev) => ({ ...prev, name: e.target.value }))}
          required
        />
        <FormField
          label="Descrição"
          type="textarea"
          value={formData.description}
          onChange={(e) => setFormData((prev) => ({ ...prev, description: e.target.value }))}
        />
        <p style={{ fontSize: '0.875rem', color: '#6b7280', marginTop: '0.5rem' }}>
          No caixa, ao finalizar com crediário, o sistema exige cliente e prazo de pagamento e gera as parcelas em Contas a Receber.
        </p>
        <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginTop: '1rem' }}>
          <input
            type="checkbox"
            checked={formData.active}
            onChange={(e) => setFormData((prev) => ({ ...prev, active: e.target.checked }))}
          />
          Ativo
        </label>
        {errors?.submit && (
          <p style={{ color: '#dc2626', marginTop: '1rem', fontSize: '0.875rem' }}>{errors.submit}</p>
        )}
      </form>
    </Modal>
  )
}

export default CrediarioModal
